function parseYmdParts(dateStr) {
  const raw = String(dateStr ?? "").trim();
  const datePart = raw.split("T")[0];
  const segs = datePart.split("-").map((x) => parseInt(x, 10));
  if (segs.length < 3 || segs.some((n) => Number.isNaN(n))) return null;
  return { y: segs[0], m: segs[1], d: segs[2] };
}

/** e.g. 1 August 2026 */
function formatBusinessDateForPrint(dateStr) {
  const parts = parseYmdParts(dateStr);
  if (!parts) return String(dateStr ?? "").trim() || "—";
  const dt = new Date(parts.y, parts.m - 1, parts.d);
  return dt.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

/** e.g. 1 August 2026 10:00 AM */
function formatOrderDateTimeForPrint(dtLocal) {
  const raw = String(dtLocal ?? "").trim();
  if (!raw) return "—";
  const [datePart, timePart = "00:00"] = raw.split("T");
  const segs = datePart.split("-").map((x) => parseInt(x, 10));
  if (segs.length < 3 || segs.some((n) => Number.isNaN(n))) return raw;
  const [y, mo, d] = segs;
  const [hh = 0, mm = 0] = timePart.split(":").map((x) => parseInt(x, 10));
  const dt = new Date(y, mo - 1, d, hh, Number.isNaN(mm) ? 0 : mm);
  const dateStr = dt.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  let hour = dt.getHours();
  const ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12;
  if (hour === 0) hour = 12;
  const minStr = String(dt.getMinutes()).padStart(2, "0");
  return `${dateStr} ${hour}:${minStr} ${ampm}`;
}

/**
 * @param {string} fetchReportBy - "BusinessDate" | "OrderDate"
 */
export function formatPeriodForPrint(fetchReportBy, dateFrom, dateTo) {
  if (!dateFrom && !dateTo) return "";
  if (fetchReportBy === "OrderDate") {
    const a = formatOrderDateTimeForPrint(dateFrom);
    const b = formatOrderDateTimeForPrint(dateTo);
    return `Period: ${a} - ${b}`;
  }
  const a = formatBusinessDateForPrint(dateFrom);
  const b = formatBusinessDateForPrint(dateTo);
  return `Period: ${a} - ${b}`;
}
